const COOKIE_KEYS = {
  accessToken: "access_token",
  refreshToken: "refresh_token",
  signature: "signature",
};

export default COOKIE_KEYS;
